import { jwtDecode } from 'jwt-decode';

let pending = null;
const BASE = (process.env.REACT_APP_API_URL || '').replace(/\/$/, '');
const fetchOriginal = typeof window !== 'undefined' ? window.fetch.bind(window) : null;
export function clearClientSession() {
  ['clientToken', 'clientRefreshToken', 'clientCaseId', 'clientEmail'].forEach(key => localStorage.removeItem(key));
  window.dispatchEvent(new CustomEvent('client-session-expired'));
}
export async function getValidClientAccessToken({ forceRefresh = false } = {}) {
  const access = localStorage.getItem('clientToken');
  try { if (!forceRefresh && jwtDecode(access).exp * 1000 - Date.now() > 60000) return access; } catch { /* Refresh below. */ }
  const refresh = localStorage.getItem('clientRefreshToken');
  if (!refresh) return null;
  if (!pending) pending = (async () => {
    const url = /\/api$/i.test(BASE) ? `${BASE}/token/refresh/` : `${BASE}/api/token/refresh/`;
    const response = await fetchOriginal(url, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ refresh }) });
    if ([400, 401, 403].includes(response.status)) { clearClientSession(); return null; }
    if (!response.ok) throw new Error('Unable to refresh the client session.');
    const data = await response.json();
    if (!data.access) throw new Error('No client access token was returned.');
    localStorage.setItem('clientToken', data.access);
    if (data.refresh) localStorage.setItem('clientRefreshToken', data.refresh);
    return data.access;
  })().finally(() => { pending = null; });
  return pending;
}

export function installClientSession() {
  const fetchNext = window.fetch.bind(window);
  window.fetch = async (input, init) => {
    let request;
    try { request = new Request(input, init); } catch { return fetchNext(input, init); }
    const old = localStorage.getItem('clientToken');
    const header = request.headers.get('Authorization');
    const baseUrl = new URL(BASE || '/api', window.location.origin);
    const requestUrl = new URL(request.url, window.location.origin);
    const path = baseUrl.pathname.replace(/\/$/, '');
    if (!old || header !== `Bearer ${old}` || requestUrl.origin !== baseUrl.origin || (path && !requestUrl.pathname.startsWith(`${path}/`))) return fetchNext(request);
    let access;
    try { access = await getValidClientAccessToken(); } catch { access = old; }
    const headers = new Headers(request.headers);
    if (access) headers.set('Authorization', `Bearer ${access}`);
    const authenticated = new Request(request, { headers });
    const retry = authenticated.clone();
    const response = await fetchNext(authenticated);
    if (response.status !== 401 || !localStorage.getItem('clientRefreshToken')) return response;
    let refreshed;
    try { refreshed = await getValidClientAccessToken({ forceRefresh: true }); } catch { return response; }
    if (!refreshed) return response;
    const retryHeaders = new Headers(retry.headers);
    retryHeaders.set('Authorization', `Bearer ${refreshed}`);
    return fetchNext(new Request(retry, { headers: retryHeaders }));
  };
}
